<era-panel>
  <div class="p-2">
    <ml-async-result [operation]="apple$">
      <p empty>Device not found!</p>

      @if (apple$ | async; as apple) {
        <div>
          @if (apple | os: { iOS: '>=7.0', macOS: '>=10.7' }) {
            <ml-mdm-apple-device-lock [apple]="apple"> </ml-mdm-apple-device-lock>
          }
          @if (apple.isSupervised) {
            <era-pane>
              <h5 class="small-caps">Power</h5>
              @if (apple | os: { iOS: '>=10.3', macOS: '>=10.13', appleTV: '>=10.3' }) {
                <ml-mdm-restart-device [class]="'btn btn-warning me-2'"
                                       [apple]="apple">
                  <fa-icon icon="redo"
                           class="me-1"></fa-icon>
                  <span i18n>Restart</span>
                </ml-mdm-restart-device>
              }
              @if (apple | os: { iOS: '>=10.3', macOS: '>=10.13' }) {
                <ml-mdm-shutdown-device [class]="'btn btn-danger'"
                                        [apple]="apple">
                  <fa-icon icon="power-off"
                           class="me-1"></fa-icon>
                  <span i18n>Shutdown</span>
                </ml-mdm-shutdown-device>
              }
            </era-pane>
          }
          @if (apple | os: { iOS: '>=9.3' }) {
            <ml-mdm-apple-lost-mode [apple]="apple"></ml-mdm-apple-lost-mode>
          }
          @if (apple | os: { iOS: '>=0.0' }) {
            <era-pane>
              <h5 class="small-caps">Passcode</h5>
              <ml-mdm-clear-passcode [class]="'btn btn-primary'"
                                     [udid]="apple.udid">
                <fa-icon icon="key"
                         class="me-1"></fa-icon>
                <span i18n>Clear passcode</span>
              </ml-mdm-clear-passcode>
            </era-pane>
          }
          @if (apple | os: { iOS: '>=9.3' }) {
            <ml-mdm-device-location [apple]="apple"></ml-mdm-device-location>
          }
          <ml-mdm-erase-device [apple]="apple"></ml-mdm-erase-device>
        </div>
      }
    </ml-async-result>
  </div>
</era-panel>